// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
const SUBMIT_FORGOT_PASSWORD = 'SUBMIT_FORGOT_PASSWORD';
const SUBMIT_FORGOT_PASSWORD_SUCCESS = 'SUBMIT_FORGOT_PASSWORD_SUCCESS';
const SUBMIT_FORGOT_PASSWORD_FAILED = 'SUBMIT_FORGOT_PASSWORD_FAILED';

const FORGOT_PASSWORD_CHANGE_FIELD = 'FORGOT_PASSWORD_CHANGE_FIELD';

const FORGOT_PASSWORD_RESET_FORM = 'FORGOT_PASSWORD_RESET_FORM';

export {
  SUBMIT_FORGOT_PASSWORD,
  SUBMIT_FORGOT_PASSWORD_SUCCESS,
  SUBMIT_FORGOT_PASSWORD_FAILED,
  FORGOT_PASSWORD_CHANGE_FIELD,

  FORGOT_PASSWORD_RESET_FORM,
};
